import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getOrdersNext } from "../ordersThunk";
import { OrdersState, State } from "../types";
import { CustomError } from "shared/api";
import { groupOrdersByDate } from "entities/orders";

export const getOrdersNextReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrdersNext.pending, state => {
			state.loadingNext = true;
		})
		.addCase(getOrdersNext.fulfilled, (state, action) => {
			state.loadingNext = false;
			const results = action.payload;

			if (!results.length) {
				state.ordersWaitingNext = [];
				state.ordersDelayedNext = [];
			}

			state.ordersDelayedNext = results.filter(order => order.state === State.DELAY)

			const groupedOrders = groupOrdersByDate(results.filter(order => order.state !== State.DELAY), state);

			state.ordersWaitingNext = groupedOrders;

			state.error = null;
		})

		.addCase(getOrdersNext.rejected, (state, action) => {
			state.loadingNext = false;
			state.error = action.payload as CustomError;
		})
}